import axios from "axios";
import params from "../configs/params";

const bMcpApi = axios.create({
  baseURL: params.mcpUrl,
  withCredentials: true,
});

bMcpApi.defaults.headers.common["Content-Type"] = "application/json";
bMcpApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

bMcpApi.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

bMcpApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          const response = await axios.post(`${params.apiUrl}auth/token/refresh/`, {
            token: refreshToken,
          });
          const newAccessToken = response.data.accessToken;
          localStorage.setItem("accessToken", newAccessToken);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return bMcpApi(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default bMcpApi;
